// src/hooks/usePageMeta.ts
import { useEffect } from 'react';

export const usePageMeta = ({
  title,
  description,
  keywords,
  og = {},
  twitter = {},
}: {
  title: string;
  description?: string;
  keywords?: string;
  og?: Record<string, string>;
  twitter?: Record<string, string>;
}) => {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attr = 'name') => {
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    if (description) setMeta('description', description);
    if (keywords) setMeta('keywords', keywords);

    Object.entries(og).forEach(([key, value]) =>
      setMeta(`og:${key}`, value, 'property')
    );

    Object.entries(twitter).forEach(([key, value]) =>
      setMeta(`twitter:${key}`, value)
    );
  }, [title, description, keywords, og, twitter]);
};
